<template>
    <BasePanel 
        headline="lang_ACCOUNT_COMPANIES_CAPTION_PUBLISHINGCOMPANY_PANEL"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="itemsPerPage"
                :header-props="{ sortIcon: '' }"
                hide-default-footer
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
            >
                <template v-slot:top>
                    <v-row class="pb-3">
                        <v-spacer></v-spacer>
                        <v-col cols="3">
                            <BaseButton 
                                @click="addNewRow"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :disabled="false"
                                :alvqa="alvqa + '-button-add-row'"
                            />
                        </v-col>
                    </v-row>
                </template>

                <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <!-- Company name -->
                <template v-slot:[`item.companyName`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-company-name'">
                        {{ item.companyName }}
                    </div>
                </template>

                <!-- Company as AZ entry -->
                <template v-slot:[`item.companyAsAzEntry`]="{ item }">
                    <div v-if="item.companyAsAzEntry != null" :alvqa="alvqa + '-list-row-' + item.id + '-text-company-as-az-entry'">
                        {{ item.companyAsAzEntry.gemaName }}
                    </div>
                </template>

                <template v-slot:[`item.ipi`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-ipi'">
                        {{ item.ipi }}
                    </div>
                </template>

                <template v-slot:[`item.alvId`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-alvid'">
                        {{ item.alvId }}
                    </div>
                </template>

                <!-- Row Button: DELETE  -->
                <!-- <template v-slot:[`item.delete`]="{ item }">
                    <BaseIcon 
                        @click="deletePublishingCompanies(item)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + 'list-row-' + item.id + '-icon-delete'"
                    />
                </template> -->

                <!-- Row Button: EDIT -->
                <template v-slot:[`item.inlineEdit`]="{ item }">
                            <BaseIcon   
                                :alvqa="alvqa + '-list-row-' + item.id + '-icon-inline-edit'"
                                icon="edit" 
                                tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"
                                @click.stop="editInlineFunction(item)"
                            />                     
                </template>
                <template v-slot:[`item.uploadPicture`]="{ item }">
                            <BaseIcon
                                :alvqa="alvqa + '-list-row-' + item.id + '-icon-upload-picture'"
                                icon="photo"
                                :tooltipText="item.logo ? 'lang_GENERAL_CAPTION_ICON_EDIT_LOGO':'lang_GENERAL_CAPTION_ICON_UPLOAD_LOGO'"
                                :color="item.logo ? 'buttonStandard' : 'standardBrownIcon'"
                                @click.stop="showImageUploadDialog(item)"
                            />
                </template>

                <!-- Row Button: DEFAULT MAPPINGS -->
                <template v-slot:[`item.defaultMappings`]="{ item }">
                    <BaseIcon
                        :alvqa="alvqa + '-list-row-' + item.id + '-icon-default-mappings'"
                        icon="tune"
                        tooltipText="lang_ACCOUNT_COMPANY_CAPTION_DEFAULT_MAPPINGS_HEADLINE"
                        @click.stop="openDefaultMappingsDialog(item)"
                    />
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel' 
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "PublishingCompaniesEditPanel",
    components: {
        BasePanel,
        BaseButton,
        BaseIcon,
    },
    data() {
        return {
            alvqa: 'account-companies-edit-form-panel-publishing-companies',
        }
    },
    computed: {
        items() { 
            return this.$store.getters.getAccountPublishingCompanies 
        },
        headers() {
            return [
                {   
                    text: this.$t('lang_GENERIC_ACCOUNT_COMPANIES_CAPTION_COMPANY_NAME'), 
                    alvqa: this.alvqa + "header-company-name",
                    align: "left", 
                    value: "companyName", 
                    class: 'text-no-wrap'
                },
                {   
                    text: this.$t('lang_ACCOUNT_COMPANIES_PUBLISHING_COMPANIES_CAPTION_AZ_CONNECTION'), 
                    alvqa: this.alvqa + "header-company-as-az-entry",
                    align: "left", 
                    value: "companyAsAzEntry", 
                    class: 'text-no-wrap'
                },
                {   
                    text: this.$t('lang_GENERIC_AZ_CAPTION_IPI'), 
                    alvqa: this.alvqa + "header-ipi",
                    align: "left", 
                    value: "ipi", 
                    tooltip: "", 
                    class: 'text-no-wrap'
                },
                {   
                    text: this.$t('lang_CAPTION_ALVID'), 
                    alvqa: this.alvqa + "header-alvid",
                    align: "left", 
                    value: "alvId", 
                    tooltip: "", 
                    class: 'text-no-wrap'
                },
                {
                    text: '',
                    value: 'uploadPicture',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                },
                {
                    text: '',
                    value: 'defaultMappings',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                },
                {
                    text: '',
                    value: 'inlineEdit',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                },
                // {
                //     text: "",
                //     align: "right",
                //     width: "70px",
                //     value: "delete",
                //     sortable: false,
                //     class: 'text-no-wrap'
                // }
            ]
        },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    },
    methods: {
        
        addNewRow() {
            // first show warning that adding companies is a paid option
            this.$store.commit('setShowPayableConfirmationDialog', true)
            this.$store.commit('setAddNewPublishingCompany', true) 
        },
        showImageUploadDialog(item){
            this.$store.commit('setImageUploaderContext','AccountPublishingCompanies')
            if(item.logo !== null){
                this.$store.commit('setImageUploaderImageExists',true)
            }
            this.$store.commit('setSelectedAccountPublishingCompanies', item)
            
            this.$store.commit("setShowImageUploadDialog",true)

        },

        editInlineFunction(item) {

            this.$store.commit('setSelectedAccountPublishingCompanies', item.id)
            if(item.companyAsAzEntry !== null){
                item.companyAsAzEntry['value'] = item.companyAsAzEntry.id
            }
            let detailsDeepCopy = JSON.parse(JSON.stringify(item))
            this.$store.commit('setAccountPublishingCompaniesEditingDialogDetails', detailsDeepCopy)
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")) // set headline
            this.$store.commit('setShowAccountPublishingCompaniesEditingDialog', true)
        },

        openDefaultMappingsDialog(item) {
            this.$store.dispatch('openCompanyDefaultMappingsDialog', {
                companyId:   item.id,
                companyType: 'publishing',
                companyName: item.companyName,
            })
        },

    },
    created() {
        this.$store.dispatch('fetchAccountInvoices')
    }
}
</script>